import { documentationFileSchema } from '@si/types';
import { get } from '@si/utils';
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { queryKeys } from './queryKeys';

const responseSchema = z.object({
  documentationFiles: z.array(documentationFileSchema),
});

interface Params {
  projectId: string;
  noRetry?: boolean;
}

export function useDocumentationFiles({ projectId, noRetry = false }: Params) {
  const url = `/projects/${projectId}/documentation-files`;

  const { data, error, isLoading, refetch, isFetching } = useQuery({
    queryKey: queryKeys.getDocumentationFiles(projectId),
    queryFn: () => get({ url, schema: responseSchema }),
    enabled: !!projectId,
    retry: !noRetry,
  });

  return {
    documentationFiles: data?.documentationFiles || [],
    error,
    isLoading,
    isFetching,
    refetch,
  };
}
